<main class="main" *ngIf="isAdmin">
  <div>
    <div class="flex-title-container">
      <h1 class="title">{{'sources.sources' | transloco }}</h1>

      <div class="flex-container">
        <div class="flex-container">
          <div class="form-group select-type">
            <div class="ds-body">
              <button type="button"
                      class="chip"
                      (click)="toggleIsBI(false);"
                      [class.selected]="!isShowBI">
                DWH
              </button>
              <button type="button"
                      class="chip"
                      (click)="toggleIsBI(true);"
                      [class.selected]="isShowBI">
                BI
              </button>
            </div>
          </div>
          <p class="amount-qty"> {{'sources.amountSources' | transloco }} ({{ amountSources }})</p>
        </div>

        <div style="flex: 1" class="flex-container">
          <div class="buttons-header">
            <button (click)="addSource()" class="add-button">{{'sources.addSource' | transloco }}</button>
            <button (click)="deleteSource()" class="delete-button">
              {{'sources.delSource' | transloco }}
            </button>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div class="content">
      <div class="scroll-wrapper">
        <table>
          <thead>
            <tr>
              <th style="border-left: none; width: 15rem;">{{'sources.nameSource' | transloco }}</th>
              <th style="width: 10rem">{{'sources.type' | transloco }}</th>
              <th style="width: 18rem">{{'sources.host' | transloco }}</th>
              <th style="width: 7rem">{{'sources.port' | transloco }}</th>
              <th style="width: 7rem;"></th>
              <th style="width: 7rem;"></th>
              <th style="width: 7rem;"></th>
              <th style="width: 7rem;"></th>
            </tr>
          </thead>
          <tbody>
            <tr (click)="selectSource(source)" *ngFor="let source of sources" [class.selected-row]="selectedSource.id === source.id">
              <td class="row">{{ source.dataSourceName }}</td>
              <td *ngIf="!isShowBI" class="row">{{ source.dbDriver }}</td>
              <td *ngIf="isShowBI" class="row">{{ source.dbType }}</td>
              <td class="row">{{ source.dbServer }}</td>
              <td class="row">{{ source.dbPort }}</td>
              <td class="row">
                <button (click)="editSource()" class="edit-button">
                  {{'sources.edit' | transloco }}
                </button>
              </td>
              <td class="row">
                <button class="openmetadata" (click)="dataCatalogSource()"
                        title="{{'sources.settings' | transloco }} Data Catalog">
                  DataCatalog
                </button>
              </td>
              <td class="row">
                <button class="agent" (click)="openAgent()"
                        title="{{'sources.agents' | transloco }}">
                  {{'sources.agents' | transloco }}
                </button>
              </td>
              <td class="row">
                <button (click)="deleteSource()" class="delete-button">
                  {{'sources.delete' | transloco }}
                </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <source-settings-dialog *ngIf="showSettings" [(isVisible)]="showSettings" [isDataCatalog]="isDataCatalog" [isAgent]="isAgent" [selectedSource]="selectedSource" [isNewSource]="isNewSource" [isShowBI]="(isShowBI)"
                            (getSources)="getSources()"></source-settings-dialog>
    <div *ngIf="showSettings" class="overlay">

    </div>
    <app-loading *ngIf="isLoading"></app-loading>

  </div>
</main>
